import { render, staticRenderFns } from "./ContactPresenterModal.vue?vue&type=template&id=1b143305"
import script from "./ContactPresenterModal.vue?vue&type=script&lang=ts"
export * from "./ContactPresenterModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports